import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { AdminIllustrations } from "@/components/AdminIllustrations";
import { BrandAssetCard } from "@/components/admin/BrandAssetCard";
import { FlyerLibrary } from "@/components/admin/FlyerLibrary";
import { GalleryUploadForm } from "@/components/admin/GalleryUploadForm";
import { GalleryItemCard } from "@/components/admin/GalleryItemCard";

export function AdminGallery() {
  const [items, setItems] = useState([]);
  const [brand, setBrand] = useState({});

  const load = async () => {
    const [g, b] = await Promise.all([api.get("/gallery"), api.get("/branding")]);
    setItems(g.data); setBrand(b.data);
  };
  useEffect(() => { load().catch(() => toast.error("Failed to load gallery")); }, []);

  return (
    <div className="space-y-8" data-testid="admin-gallery">
      <BrandAssetCard assetKey="logo" title="Logo" url={brand.logo_url} onChange={load}
        hint="Shows in the header and footer. Leave empty to use the built-in van-style Dr.Gadget wordmark (crisp on every screen)." />
      <BrandAssetCard assetKey="flyer" title="Flyer" url={brand.flyer_url} onChange={load} wide
        hint="Large flyer shown at the very top of the home page (tapping it opens Book a Session). Square image works best." />
      <FlyerLibrary flyers={brand.flyers} currentUrl={brand.flyer_url} onChange={load} />

      <AdminIllustrations />

      <GalleryUploadForm onUploaded={load} />

      <div>
        <div className="dg-eyebrow mb-3">Gallery photos ({items.length})</div>
        {items.length === 0 && <div className="text-slate-500 text-sm">No photos yet — the site shows sample images until you add your own.</div>}
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((it) => <GalleryItemCard key={it.id} item={it} onChanged={load} />)}
        </div>
      </div>
    </div>
  );
}
